import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import ExperienceCard from "@/components/base/ExperienceCard";
import CTAPanel from "@/components/base/CTAPanel";

const indiaProjects = [
  {
    client: "Gujarat State Electricity Corporation Limited (GSECL)",
    country: "India",
    location: "Gujarat",
    icon: "ri-flashlight-line",
    project: "Design, Development and Integration of Biometric Attendance System with eUrja ERP",
    scope: "Mitaja Corporation provided subcontract technology services supporting a biometric attendance system initiative involving integration with GSECL's eUrja ERP environment.",
    capabilities: [
      "Application Development",
      "System Integration",
      "ERP-related Integration",
      "Biometric Systems",
      "Workflow Automation",
    ],
    technologies: [
      "Biometric Attendance",
      "ERP Integration",
      "Enterprise Applications",
    ],
  },
  {
    client: "Redhakhol Nursery Management System (FMS)",
    country: "India",
    location: "Odisha",
    icon: "ri-plant-line",
    project: "Nursery Management System — FMS Initiative",
    scope: "Mitaja Corporation provided subcontract technology services supporting a nursery management system, including requirements and database-design documentation for a structured, database-backed management application.",
    capabilities: [
      "Requirements Analysis",
      "Database Design",
      "Application Development",
      "Database-Backed Systems",
    ],
    technologies: [
      "Database Systems",
      "SQL",
      "Application Development",
    ],
  },
  {
    client: "MGSU — Website & Portal Initiative",
    country: "India",
    location: "Rajasthan",
    icon: "ri-graduation-cap-line",
    project: "Website / Portal Content and Dependency Management",
    scope: "Mitaja Corporation provided subcontract technology services supporting website and portal activities, including content updates, dependency tracking, and chatbot requirements coordination.",
    capabilities: [
      "Web & Digital Solutions",
      "Portal Management",
      "Content Management",
      "Requirements Coordination",
    ],
    technologies: [
      "Web Applications",
      "Web Portals",
      "CMS",
    ],
  },
  {
    client: "HCMS / Heavy Water — Human Capital System Initiative",
    country: "India",
    location: "Maharashtra",
    icon: "ri-team-line",
    project: "Human Capital Management System (HCMS)",
    scope: "Mitaja Corporation provided subcontract technology services supporting a human capital management system initiative, including user stories, workflow documentation, wireframes, and requirements coordination.",
    capabilities: [
      "Application Development",
      "Workflow Design",
      "Requirements Analysis",
      "Delivery",
    ],
    technologies: [
      "Web Applications",
      "Workflow Systems",
      "Database-Backed Applications",
    ],
  },
  {
    client: "WEBEL — Technology Systems Initiative",
    country: "India",
    location: "West Bengal",
    icon: "ri-code-s-slash-line",
    project: "Enterprise Technology Systems Support",
    scope: "Mitaja Corporation provided subcontract technology services supporting an enterprise technology initiative, with scope and delivery defined by documentation.",
    capabilities: [
      "Enterprise Applications",
      "Application Support",
      "Systems Integration",
    ],
    technologies: [
      "Enterprise Systems",
      "Application Development",
    ],
  },
  {
    client: "Pune HRMS — Human Resource Management System",
    country: "India",
    location: "Maharashtra",
    icon: "ri-user-settings-line",
    project: "Human Resource Management System (HRMS)",
    scope: "Mitaja Corporation provided subcontract technology services supporting a human resource management system, based on documented user stories and requirements.",
    capabilities: [
      "Application Development",
      "Requirements Analysis",
      "Workflow Design",
      "Module Implementation",
    ],
    technologies: [
      "Web Applications",
      "Database Systems",
      "Workflow Systems",
    ],
  },
];

export default function InternationalExperience() {
  return (
    <Layout>
      <PageHero
        title="International Government Technology Experience"
        subtitle="Experience · International · India"
        description="Mitaja Corporation has provided subcontract technology services supporting public-sector and enterprise technology initiatives in India. These engagements broaden Mitaja's delivery experience across custom applications, digital platforms, enterprise systems, database-backed solutions, workflow modernization and systems integration."
        size="lg"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <div className="max-w-3xl mx-auto mb-14">
            <div className="bg-accent-50 border border-accent-200 rounded-lg p-6">
              <div className="flex items-start gap-3">
                <i className="ri-global-line text-accent-600 text-xl mt-0.5 shrink-0"></i>
                <div>
                  <h3 className="text-sm font-bold text-accent-800 uppercase tracking-wider mb-2">
                    Subcontract Performance — India
                  </h3>
                  <p className="text-sm text-accent-700 leading-relaxed">
                    Mitaja's India experience is delivered as a subcontractor through higher-tier prime contractors. End clients shown are not direct-award relationships, and prime or intermediary contractor names are not disclosed publicly.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3 mb-8">
            <span className="text-sm font-bold uppercase tracking-wider text-primary-800">
              India Portfolio
            </span>
            <div className="h-px flex-1 bg-background-200"></div>
            <span className="text-xs text-foreground-500">Verified subcontract engagements</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {indiaProjects.map((project) => (
              <ExperienceCard key={project.client} {...project} />
            ))}
          </div>
        </div>
      </section>

      <CTAPanel
        title="Leveraging International Delivery Experience"
        description="Mitaja's international delivery complements its U.S. government technology experience to support complex, multi-environment initiatives."
        primaryAction={{ label: "Explore Capabilities", href: "/capabilities" }}
        secondaryAction={{ label: "Contact Business Development", href: "/contact" }}
        variant="dark"
      />
    </Layout>
  );
}